export const PhDAdminUsers: string[] = ['jsbailey', 'adumble', 'aoeaoe']

export const PhDAssessorRole = 'PhD Assessor'
